export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    sizeValue,
    visible
  } = _ref;
  return {
    rootStyle: {
      backgroundColor: visible ? designContext.get('colors/text/accent').toString() : designContext.get('colors/backgrounds/transparent').toString(),
      minHeight: 10,
      width: sizeValue
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map